import { render, staticRenderFns } from "./ModalSampleEdit.vue?vue&type=template&id=5fbfc5d4&scoped=true&"
import script from "./ModalSampleEdit.vue?vue&type=script&lang=ts&"
export * from "./ModalSampleEdit.vue?vue&type=script&lang=ts&"
import style0 from "./ModalSampleEdit.vue?vue&type=style&index=0&id=5fbfc5d4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fbfc5d4",
  null
  
)

export default component.exports